import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { RuntimeService } from '../../shared/services/runtime.service';

export const mfaGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const runtime = inject(RuntimeService);
  const router = inject(Router);

  if (authService.isMfaPending()) {
    return true;
  }

  // Already fully authenticated — go to the app
  if (authService.isLoggedIn()) {
    return router.createUrlTree(['/load-planning']);
  }

  if (runtime.IsDesktopApplication && !authService.hasLicence()) {
    return router.createUrlTree(['/verify-licence']);
  }

  // Not authenticated at all — go to the appropriate entry point
  const destination = runtime.IsDesktopApplication ? '/switch-account' : '/login';
  return router.createUrlTree([destination]);
};
